"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("section", {
    staticClass: "exporter"
  }, [_c("div", {
    ref: "printArea",
    staticClass: "print-container",
    class: {
      "show-print-container": _vm.showPrintContainer
    }
  }, [_c("SummaryAttendancesMonth", {
    attrs: {
      "start-date": _vm.data.startDate,
      "end-date": _vm.data.endDate,
      "timesheets-daily": _vm.data.timesheetsDaily,
      "shift-hours": _vm.data.shiftHours,
      user: _vm.data.user,
      farm: _vm.data.farm
    }
  })], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;